import {useEffect, useMemo} from "react";
import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";
import {useLocation, useNavigate} from "react-router-dom";
import {getCookie} from "react-use-cookie";
import {Form, Formik} from "formik";
import {object, string} from "yup";

import {lastUpdateDate} from "../../gitIgnore/updateDate";
import {clearPreviousUserLocation, login, selectIsAuth, selectPreviousUserLocation} from "../../slices/UserSlice";
import FunctionButton from "../../utilities/Buttons/FunctionButton";
import {UI_PERMISSION_TYPE} from "../adminForms/Ba3aSettings/tabs/PositionsSettings/useRoutePermissions";
import {TextInput} from "../Inputs";
import PasswordInput from "../Inputs/PasswordInput/PasswordInput";

const LoginForm = () => {
  const {t} = useTranslation();

  const dispatch = useDispatch();

  const {user} = useSelector(state => state.user);
  const isAuth = useSelector(selectIsAuth);
  const token = getCookie("access_token");
  const previousUserLocation = useSelector(selectPreviousUserLocation);

  const navigate = useNavigate();
  const location = useLocation();
  const navigateAfterLoginLocation = location.state?.from || previousUserLocation || "/ba3a/main";

  const initialValues = useMemo(() => {
    return {
      login: "",
      password: "",
    };
  }, []);

  useEffect(() => {
    if (isAuth && token && user?.login) {
      navigate(navigateAfterLoginLocation);
      dispatch(clearPreviousUserLocation());
    }
  }, [isAuth, token, user?.login, navigateAfterLoginLocation]);

  const resultLastUpdateDate =
    process.env.REACT_APP_LAST_UPDATE_DATE || window.__APP_INFO__?.lastUpdateDate || lastUpdateDate || "not set";

  return (
    <div className="login-form__container">
      <div className="login_form">
        <label className="label login_form_label">{t("Auth")}</label>
        <Formik
          initialValues={initialValues}
          validationSchema={object().shape({
            login: string().required(t("Enter Login")),
            password: string().required(t("Enter Password")),
          })}
          validateOnChange={true}
          validateOnBlur={true}
          enableReinitialize
          onSubmit={values => {
            dispatch(login(values)).catch(err => console.error(err));
          }}
        >
          {() => (
            <Form className="project_form">
              <TextInput
                label="Login"
                id="login"
                name="login"
                type="text"
                uiPermissionType={UI_PERMISSION_TYPE.READABLE}
              />
              <PasswordInput label={t("Password")} id="password" name="password" />
              <p>
                {t("Update")}: {resultLastUpdateDate}
              </p>
              <FunctionButton type="submit" name="Sign in" uiPermissionType={UI_PERMISSION_TYPE.READABLE} />
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default LoginForm;
